<template>
  <div>
    <div
      v-if="notes.length > 0"
    >
      <div
        v-for="(note, i) in notes"
        :key="`note_${note.id}`"
      >
        <hr
          v-if="i !== 0"
        >
        <note
          class="border-0"
          :note="note"
          @deleted="onDelete(i)"
        ></note>
      </div>
    </div>
    <div
      v-else
    >
      <div
        v-if="!loaded"
      >
        <i class="fa fa-circle-o-notch fa-spin mr-1"></i>
        Loading notes...
      </div>
      <div
        v-else
      >
        There are no notes.
      </div>
    </div>
  </div>
</template>

<script>
import { getNotes, createNote } from '@/api'
import Note from '@/components/Note'

export default {
  components: {
    Note
  },
  props: {
    annotatableType: {
      type: String,
      required: true
    },
    annotatableId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      notes: [],
      loaded: false
    }
  },
  watch: {
    annotatableType () {
      this.loadNotes()
    },
    annotatableId () {
      this.loadNotes()
    }
  },
  mounted () {
    this.loadNotes()
  },
  methods: {
    async loadNotes () {
      this.notes = []
      this.loaded = false
      let response = await getNotes(this.annotatableType, this.annotatableId)
      this.notes = response.data.data
      this.loaded = true
    },
    async createNote (content) {
      let response = await createNote(this.annotatableType, this.annotatableId, content)
      let note = response.data.data
      note.editing = true
      this.notes.unshift(note)
    },
    onDelete (i) {
      this.notes.splice(i, 1)
    }
  }
}
</script>